<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" v-if="getPermission('ymsDeliveryPlace_insertDeliveryPlace')"
        @click="$refs['deliveryLocation'].initDeliveryLocationData('add')">{{ $t('key1002185') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增、编辑发货地弹窗-->
    <deliveryLocationModal
      ref="deliveryLocation"
      :shippingCountryData="shippingCountryData"
      @updateData="search">
    </deliveryLocationModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import deliveryLocationModal from "@/views/yms/components/basicSettings/deliveryLocationModal.vue";
import api from '@/api/';
import {getNationalContinentName, getRegionalRcountriesData} from "@/utils/common";

export default {
  name: 'deliveryLocationManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParams: {
        pageNum: 1,
        pageSize: 15,
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002181'),
          key: 'deliveryPlaceName',
          align: 'center',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002182'),
          key: 'countryCodes',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            let ymsDeliveryPlaceCountryList = params.row.ymsDeliveryPlaceCountryList || [];
            let countryCodes = ymsDeliveryPlaceCountryList.map((item) => item.deliveryCountry);
            const list = getNationalContinentName(countryCodes, v.shippingCountryData, 'name');
            return h('span', list.join('、'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002183'),
          key: 'allowCollectGoods',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let text = params.row.allowCollectGoods === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 140,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                isShowMoreBtn: false,
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('ymsDeliveryPlace_updateDeliveryPlace'),
                    clickFn: () => {
                      v.$refs['deliveryLocation'].initDeliveryLocationData('edit', params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      shippingCountryData: [],
    };
  },
  created() {
    getRegionalRcountriesData().then((data) => {
      let newData = [];
      if (data.length > 0) {
        data.forEach((item) => {
          let countriesList = item.countries || [];
          countriesList.forEach((ele) => {
            ele.name = ele.cnName;
            ele.title = ele.cnName;
          });
          newData.push({
            twoCode: item.zoneCode + '_area',
            continent: item.zoneCode + '_area',
            title: item.zoneCnName,
            children: countriesList,
          });
        });
      }
      this.shippingCountryData = newData;
      this.pageParams.pageNum = 1;
      this.search();
    });
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      if (v.getPermission('ymsDeliveryPlace_query')) {
        v.optionBtnWidth = [];
        v.tableData = [];
        v.tableLoading = true;
        v.axios.post(api.post_ymsDeliveryPlace_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.tableData.map((item) => {
                item.allowCollectGoods = Number(item.allowCollectGoods);
              });
              v.updateTableDom('selection');
            }
          }
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
  },
  components: {
    deliveryLocationModal
  }
};
</script>

<style lang="less">

</style>
